import React from "react";
import Marquee from "react-fast-marquee";
import checkBox from "../iamges/CheckSquareOffset.png";

const GetHomeOwnerApp = () => {
  const validations = [
    "Start your free month",
    "No card needed",
    "One-time $20 to unlock. No subscription.",
  ];
  return (
    <div
      className='flex justify-center items-center flex-col'
      style={{
        backgroundColor: "rgba(255, 178, 0, 0.12)",
      }}>
      <div className='max-w-[848px] relative mt-[64px]'>
        <h1
          className='text-center text-[#101828] lg:text-[44px] md:text-[36px] text-[32px] plus-jakarta-sans'
          style={{ fontWeight: "800" }}>
          Start Your{" "}
          <span style={{ color: "#FF9D00" }}>Property Management</span> Journey
          Today
        </h1>
        <p
          className='text-center text-[16px] mt-2 text-[#667085]'
          style={{
            fontWeight: 500,
          }}>
          Set up in under 5 minutes. Try every rental feature free for 30 days,
          then unlock it all with a one-time $20 purchase. No subscription.
        </p>

        <div className='flex flex-wrap gap-4 justify-center items-center mt-10 mb-12 max-w-[600px] mx-auto'>
          {validations.map((item, index) => (
            <div
              key={index}
              className='flex items-center mt-6 max-w-[500px] mx-auto'>
              <img
                src={checkBox}
                alt=''
                style={{ width: 24, height: 24 }}
                className=''
              />
              <p
                className='text-[14px] ml-3 text-[#667085]'
                style={{ fontWeight: 500 }}>
                {item}
              </p>
            </div>
          ))}
        </div>

        <div
          style={{ marginTop: 12, marginBottom: 40 }}
          className='bg-[#FF9D00] lg:h-[65px]  md:h-[55px] h-[46px] w-[323px] flex justify-center items-center mx-auto rounded-[12px]'>
          <p
            className='text-white text-[20px] '
            style={{ fontFamily: "Plus Jakarta Sans", fontWeight: "600" }}>
            Start your free month trial
          </p>
        </div>

        {/* <div
          style={{ marginTop: 35 }}
          className='flex justify-center items-center mx-auto '>
          <a
            target='_blank'
            href='https://play.google.com/store/apps/details?id=com.arptix.homeowner'
            style={{
              borderRadius: 5,
              border: "1px solid #DAE0E6",
              background: "var(--Base-White, #FFF)",
            }}
            className='flex items-center w-[7.5rem] h-[46px] bg-[#FFF] rounded-md '>
            <img
              src={require("../iamges/playstoreBlack.png")}
              style={{ width: 88 }}
              alt=''
              className='mx-auto'
            />
          </a>
          <a
            target='_blank'
            href='https://apps.apple.com/ca/app/homeowner/id6448795356'
            style={{
              borderRadius: 5,
              border: "1px solid var(--Neutral-700, #DAE0E6)",
              background: "var(--Base-White, #FFF)",
            }}
            className='flex items-center w-[7.5rem]  h-[46px] bg-[#FFF] rounded-md ml-7'>
            <img
              style={{ width: 88 }}
              src={require("../iamges/appStoreBlack.png")}
              alt=''
              className='mx-auto'
            />
          </a>
        </div> */}
        <img
          src={require("../iamges/Group_1000004948-removebg-preview.png")}
          alt=''
          style={{}}
          className=''
        />
      </div>

      {/* <Marquee
        speed={120}
        style={{
          marginBottom: 20,
          fontFamily: "Plus Jakarta Sans",
          fontSize: "110px",
          fontStyle: "normal",
          fontWeight: "700",
        }}
      >
        <h1 className="lg:text-[110px] text-[48px]">HomeOwner made it easy!</h1>
      </Marquee> */}
    </div>
  );
};

export default GetHomeOwnerApp;
